import type { BrandingConfig } from "./types";


import appHorizontalSplitLight from "../../assets/brand/tenants/warrior-trading/app/logo-horizontal-split-light.svg";
import appHorizontalSplitDark from "../../assets/brand/tenants/warrior-trading/app/logo-horizontal-split-dark-glow.svg";
import appHorizontalLockupLight from "../../assets/brand/tenants/warrior-trading/app/logo-horizontal-light.svg";
import appHorizontalLockupDark from "../../assets/brand/tenants/warrior-trading/app/logo-horizontal-dark.svg";
import appStackedLight from "../../assets/brand/tenants/warrior-trading/app/logo-stacked-light.svg";
import appStackedDark from "../../assets/brand/tenants/warrior-trading/app/logo-stacked-dark.svg";
import appSymbolLight from "../../assets/brand/tenants/warrior-trading/app/logo-symbol-light.svg";
import appSymbolDark from "../../assets/brand/tenants/warrior-trading/app/logo-symbol-dark.svg";

import companyHorizontalLight from "../../assets/brand/tenants/warrior-trading/company/logo-horizontal-light.svg";
import companyHorizontalDark from "../../assets/brand/tenants/warrior-trading/company/logo-horizontal-dark.svg";
import companyStackedLight from "../../assets/brand/tenants/warrior-trading/company/logo-stacked-light.svg";
import companyStackedDark from "../../assets/brand/tenants/warrior-trading/company/logo-stacked-dark.svg";
import companySymbolLight from "../../assets/brand/tenants/warrior-trading/company/logo-symbol-light.svg";
import companySymbolDark from "../../assets/brand/tenants/warrior-trading/company/logo-symbol-dark.svg";

import brandCopy from "./brand-copy.json";

export const warriorTradingBranding: BrandingConfig = {
  tenantId: "warrior-trading",
  appName: "Warrior Trading",
  companyName: "Warrior Trading",
  whiteLabel: true,
  showPoweredBy: false,
  signupFlow: 'checkout',
  copy: brandCopy["warrior-trading"],
  supportEmail: "support@warriortrading.com",
  websiteUrl: "https://warriortrading.com",
  authUi: {
    showSignupLogo: true,
    portalLabel: 'Client portal',
    signupPortalLabel: 'Start Free Trial',
  },
  logos: {
    app: {
      horizontalSplitLight: appHorizontalSplitLight,
      horizontalSplitDark: appHorizontalSplitDark,
      horizontalLockupLight: appHorizontalLockupLight,
      horizontalLockupDark: appHorizontalLockupDark,
      stackedLight: appStackedLight,
      stackedDark: appStackedDark,
      symbolLight: appSymbolLight,
      symbolDark: appSymbolDark,
    },
    company: {
      horizontalLight: companyHorizontalLight,
      horizontalDark: companyHorizontalDark,
      stackedLight: companyStackedLight,
      stackedDark: companyStackedDark,
      symbolLight: companySymbolLight,
      symbolDark: companySymbolDark,
    },
    appLogoSizing: {
      horizontalSplit: { scale: 1.1 },
      horizontalLockup: { scale: 1 },
      stacked: { scale: 0.95 },
      symbol: { scale: 1.2},
    },
    topNavLogoScale: 1.4,
    companyLogoSizing: {
      horizontal: { scale: 1 },
      stacked: { scale: 1 },
      symbol: { scale: 1 },
    },
    navLogoGlow: {
      glowOpacityLight: 0.06,
      glowOpacityDark: 0.78,
      shieldOpacityLight: 0.11,
      shieldOpacityDark: 0.96,
      // Top-nav shield glow — intentionally slightly stronger than the loading-page
      // glow (index.html #bootstrap-shell .workspace-loader__brand-logo filter) so
      // the cyan rim reads clearly in the header without becoming a broad spotlight.
      shieldFilterLight: 'drop-shadow(0 0 6px rgba(96, 165, 250, 0.46)) drop-shadow(0 0 16px rgba(56, 189, 248, 0.24)) brightness(1.25) contrast(1.06)',
      shieldFilterDark: 'drop-shadow(0 0 6px rgba(96, 165, 250, 0.46)) drop-shadow(0 0 16px rgba(56, 189, 248, 0.24)) brightness(1.25) contrast(1.06)',
      haloWidth: 96,
      haloHeight: 96,
      haloOffsetX: 2.55,
      haloOffsetY: 0,
      haloBlur: 4,
    },
    favicon: "/favicon.ico",
    faviconSvg: "/favicon.svg",
    appleTouchIcon: "/apple-touch-icon.png",
    manifest: "/site.webmanifest",
    ogImage: companyHorizontalLight,
  },
};

export default warriorTradingBranding;
